import React from 'react';
import cn from 'classnames';

import Space from 'components/generic/Space.component';
import Tooltip from 'components/generic/Tooltip.component';
import TooltipContentReceptionist from 'components/generic/TooltipContentReceptionist.component';
import { useTheme } from 'providers/Theme.provider';

import CN from './ForbiddenMenuItem.module.scss';

const ForbiddenMenuItem = ({ title, icon }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="ForbiddenMenuItem"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <Tooltip variant="slickTop" content={<TooltipContentReceptionist />}>
        <div className={CN.item}>
          <img src={icon} alt={title} className={CN.menuIcon} />
          <Space>{title}</Space>
        </div>
      </Tooltip>
    </div>
  );
};

export default ForbiddenMenuItem;
